module.exports = __webpack_public_path__ + "static/img/12.920fb74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/12.png
// module id = rnyf
// module chunks = 0